<div class="material-page">
  
  <div class="mdc-layout-grid">
    
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-12-tablet">
        <div>
          <h1 class="mat-headline-3" i18n>Turn Unused Stuff Into Cash!</h1>
          <p i18n>
            Simplify your life and earn money with Green Box.
          </p>
          <button 
              mat-raised-button 
              type="button"
              color="accent"
              [routerLink]="['/green-box']" fragment="request"
              angulartics2On="click" angularticsAction="Button Pressed" angularticsCategory="GET YOUR GREEN BOX" angularticsLabel="GET YOUR GREEN BOX"
              i18n>
              GET YOUR GREEN BOX
            </button>
        </div>
      </div>
      
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop">
        <h2 style="margin-bottom: 0px !important" class="mat-headline-4" i18n>How It Works?</h2>
      </div>
      
      <div class="section-with-img mdc-layout-grid__cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-8-tablet">
        <div class="section-img">
          <img-with-placeholder [placeholder]="'/green-box/green_box_column_1_placeholder.webp' | assetUrl">
            <img 
                fullSizedImage
                ngSrc="/green-box/green_box_column_1.webp" 
                ngSrcset="1x, 2x" 
                sizes="(max-width: 599px) 100vw, 398px"
                width="398" 
                height="398"/>
          </img-with-placeholder>
        </div>
        <h2 i18n>Order Your Box</h2>
        <p i18n>Fill out a quick form to get your Green Box delivered to your doorstep.</p>
      </div>
      
      <div class="section-with-img mdc-layout-grid__cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-8-tablet">
        <div class="section-img">
          <img-with-placeholder [placeholder]="'/green-box/green_box_column_2_placeholder.webp' | assetUrl">
            <img 
                fullSizedImage
                ngSrc="/green-box/green_box_column_2.webp" 
                ngSrcset="1x, 2x" 
                sizes="(max-width: 599px) 100vw, 398px"
                width="398" 
                height="398"/>
          </img-with-placeholder>
        </div>
        <h2 i18n>Pack & Schedule Pickup</h2>
        <p i18n>Fill your box with items, then schedule a free pickup. (<a (click)="onFragmentClick('whatCanIPut', $event)" class="mid-text">What can I put in the box?</a>) </p>
      </div>
    
      <div class="section-with-img mdc-layout-grid__cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-8-tablet">
        <div class="section-img">
          <img-with-placeholder [placeholder]="'/green-box/green_box_column_3_placeholder.webp' | assetUrl">
            <img 
                fullSizedImage
                ngSrc="/green-box/green_box_column_3.webp" 
                ngSrcset="1x, 2x" 
                sizes="(max-width: 599px) 100vw, 398px"
                width="398" 
                height="398"/>
          </img-with-placeholder>
        </div>
        <h2 i18n>Earn Money</h2>
        <p i18n>We sell your items, and you get 50% of the proceeds. (<a (click)="onFragmentClick('fees', $event)" class="mid-text">Learn more about fees</a>)</p>
      </div>
    
      <div class="mdc-layout-grid__cell--span-12">
        <h2 class="mat-headline-4" i18n>Why Choose Green Box?</h2>
        <ul id="request">
          <li i18n>Declutter Has Never Been Easier</li>
          <li i18n>Free Delivery and Pickup</li>
          <li i18n>Earn 50% on Sales</li>
          <li i18n>Items Can Be Donated With Ease If Not Sold</li>
        </ul>
      </div>
      
      <div class="get-box-form mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <h2 class="mat-headline-4" i18n>Request Your Green Box</h2>
        <form [formGroup]="greenBoxRequestForm" (ngSubmit)="sendRequest()" style="display: flex; flex-direction: column">
          <div>
            <mat-form-field class="form-text-field">
              <mat-label i18n>Full name</mat-label>
              <input matInput formControlName="name" required>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label i18n>Phone</mat-label>
              <input matInput formControlName="phone" required>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label i18n>Email</mat-label>
              <input matInput formControlName="email" required>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label i18n>Address</mat-label>
              <textarea type="text" matInput formControlName="address" required></textarea>
            </mat-form-field>
          </div>
                 
          <span>     
            <button 
              mat-raised-button 
              type="submit"
              color="accent"
              [disabled]="!canSubmitForm"
              angulartics2On="click" angularticsAction="Button Pressed" angularticsCategory="REQUEST BOX" angularticsLabel="REQUEST BOX"
              i18n>
              REQUEST BOX
            </button>
          </span>
          
          <div>
            <mat-checkbox (change)="toggleFormSubmitAvailability($event.checked)" i18n>
              I agree to the terms and condition of the service (<a [routerLink]="['/green-box/tac']" class="mid-text">read more</a>)
            </mat-checkbox>
          </div>
          
        </form>
      </div>

      <div class="mdc-layout-grid__cell--span-12">
        <h2 class="mat-headline-4" i18n>FAQ</h2>
        
        <mat-accordion multi>
          <mat-expansion-panel [expanded]="expandFAQSection === 'whatCanIPut'">
            <mat-expansion-panel-header #whatCanIPut>
              <mat-panel-title i18n>What items can I pack?</mat-panel-title>
            </mat-expansion-panel-header>
            <p i18n>The items should have meaningful value and use for someone else and be resellable. As such, the items should be clean, complete, and functional. Items that are worn out or have an estimated resale price below 10 EUR are very hard to sell.</p>
            <p i18n>We do not accept:</p>
            <ul>
              <li i18n>Tableware and cutlery.</li>
              <li i18n>Counterfeits, replicas, or bootlegs.</li>
              <li i18n>Used beauty products (e.g., makeup, sunscreen, oral and dental care items) unless they are in mint condition.</li>
              <li i18n>Items that are illegal, hazardous, or not suitable for resale.</li>
            </ul>
          </mat-expansion-panel>
          
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title i18n>How are items priced?</mat-panel-title>
            </mat-expansion-panel-header>
            <p i18n>After going through your items and assigning suggested sales prices for all resellable items, we share the list with you. Then it’s your chance to review the prices, propose changes or remove items from sale if the suggested sales price doesn’t meet you expectations.</p>
          </mat-expansion-panel>
          
          <mat-expansion-panel [expanded]="expandFAQSection === 'fees'">
            <mat-expansion-panel-header #fees>
              <mat-panel-title i18n>How much does it cost and how do I get paid?</mat-panel-title>
            </mat-expansion-panel-header>
            <p i18n>We will transfer you 50% of the sales value for items sold. Payments are transferred to your bank account weekly.</p>
          </mat-expansion-panel>
          
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title i18n>What happens to the items that Listx deems not suitable for resale?</mat-panel-title>
            </mat-expansion-panel-header>
            <p i18n>After our experts have gone through the items, we will let you know what has resale potential and what doesn’t. Then it’s up to you whether you would like to have the non-sellable items returned to you or donated to charity.</p>
          </mat-expansion-panel>
          
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title i18n>What happens if my item doesn’t sell?</mat-panel-title>
            </mat-expansion-panel-header>
            <p i18n>After 8 weeks, you can choose to keep the item listed for more time at a reduced listing price, donate it to charity, or have it returned to you.</p>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </div>
</div>